<ng-container>
  <div class="card mt-20">
    <div class="body">
      <table mat-table [dataSource]="buyOfferList" matSort matSortActive="UtilityName" matSortDisableClear matSortDirection="asc" class="offer-summmary-table">
        <ng-container matColumnDef="#">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
          <td mat-cell *matCellDef="let element,let i =index">{{i+1}}</td>
        </ng-container>
        <ng-container matColumnDef="UtilityName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Utility</th>
          <td mat-cell *matCellDef="let element"> {{element.accounts[0].utility.name}} </td>
        </ng-container>
        <ng-container matColumnDef="LoadZone">
          <th mat-header-cell *matHeaderCellDef>Load Zone</th>
          <td mat-cell *matCellDef="let element"> {{element.accounts[0].loadZone.name}} </td>
        </ng-container>
        <ng-container matColumnDef="RateClass">
          <th mat-header-cell *matHeaderCellDef>Rate Class</th>
          <td mat-cell *matCellDef="let element"> {{element.accounts[0].rateClass.name}} </td>
        </ng-container>
        <ng-container matColumnDef="TermFrom">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Starting On</th>
          <td mat-cell *matCellDef="let element"> {{element.termFrom | date:'shortDate'}} </td>
        </ng-container>
        <ng-container matColumnDef="TermPeriod">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Term Period</th>
          <td mat-cell *matCellDef="let element"> {{element.termPeriod}} months</td>
        </ng-container>
        <ng-container matColumnDef="TargetPrice">
          <th mat-header-cell *matHeaderCellDef>Buyer's Price</th>
          <td mat-cell *matCellDef="let element"> {{element.priceForSeller() | currency:'USD':'symbol':'1.5-5'}}/kWh </td>
        </ng-container>
        <ng-container matColumnDef="Fee">
          <th mat-header-cell *matHeaderCellDef>License Fee</th>
          <td mat-cell *matCellDef="let element"> {{element.fee | currency:'USD':'symbol':'1.5-5'}}/kWh </td>
        </ng-container>
        <ng-container matColumnDef="Price">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Sales Price <div class="notifiedIconSmall cursor-pointer" (click)="iIconPopup('Sales Price includes Licence Fee. Seller\'s price is estimated as Sales Price minus License Fee.')"></div></th>
          <td mat-cell *matCellDef="let element"> {{element.priceForBuyer() | currency:'USD':'symbol':'1.5-5'}}/kWh </td>
        </ng-container>
        <ng-container matColumnDef="ValidDate">
          <th mat-header-cell *matHeaderCellDef>Valid Until</th>
          <td mat-cell *matCellDef="let element"> {{element.validDate | date:'short'}} EST</td>
        </ng-container>
        <ng-container matColumnDef="Accounts">
          <th mat-header-cell *matHeaderCellDef>Accounts</th>
          <td mat-cell *matCellDef="let element"> {{element.accounts.length}} </td>
        </ng-container>
        <ng-container matColumnDef="Action">
          <th mat-header-cell *matHeaderCellDef>Accept</th>
          <td mat-cell *matCellDef="let element,let i = index">
            <a class="link f18" (click)="acceptBuyOffer(element)">
              <mat-icon class="customIcons">insert_drive_file</mat-icon>
            </a>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row [class]="(row.isNewRecord)?'higlighted':''" (click)="markBuyOfferNotNew(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator [hidePageSize]="true" [length]="total" showFirstLastButtons [pageSize]="RECS_PER_PAGE" aria-label="Select page"></mat-paginator>
    </div>
  </div>
</ng-container>
